import { redirect } from "react-router-dom";
import { SignOutSession } from "../repo/SessionsRepo";

export async function action() {
  await SignOutSession()
  return redirect('/')
}
